/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Position_Modal_Line_Position_LabelInputs */

const en_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Line Position (1-${i?.max})`)
};

const fr_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position des lignes (1-${i?.max})`)
};

const de_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linienposition (1-${i?.max})`)
};

const it_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posizione della linea (1-${i?.max})`)
};

const ru_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Позиция линии (1-${i?.max})`)
};

const es_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posición de línea (1-${i?.max})`)
};

const zh_cn2_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`线路位置（1-${i?.max}）`)
};

const ja_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラインポジション (1-${i?.max})`)
};

const hi_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लाइन स्थिति (1-${i?.max})`)
};

const pt_pt2_position_modal_line_position_label = /** @type {(inputs: Position_Modal_Line_Position_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posição da linha (1-${i?.max})`)
};

/**
* | output |
* | --- |
* | "Line Position (1-{max})" |
*
* @param {Position_Modal_Line_Position_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_line_position_label = /** @type {((inputs: Position_Modal_Line_Position_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Line_Position_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_line_position_label(inputs)
	if (locale === "de") return de_position_modal_line_position_label(inputs)
	if (locale === "it") return it_position_modal_line_position_label(inputs)
	if (locale === "ru") return ru_position_modal_line_position_label(inputs)
	if (locale === "es") return es_position_modal_line_position_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_line_position_label(inputs)
	if (locale === "ja") return ja_position_modal_line_position_label(inputs)
	if (locale === "hi") return hi_position_modal_line_position_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_line_position_label(inputs)
	return en_position_modal_line_position_label(inputs)
});